import commissionScheduleApi from 'Agent/Commissions/api/commissionScheduleApi';
import {
  changeCommissionSchedules,
  CommissionSchedulesActionType,
  getCommissionSchedules,
} from 'Agent/Commissions/ducks/commissionSchedules';
import {CommissionSchedule} from 'Agent/Commissions/models/CommissionSchedule';
import {AsyncResult, fromResult, Loading, LoadingAdditional} from 'Core/models/Async';
import {Page} from 'Core/models/Page';
import * as E from 'fp-ts/lib/Either';
import {pipe} from 'fp-ts/lib/pipeable';
import {all, call, put, takeLatest} from 'redux-saga/effects';
import {mergeWithNextPage} from 'Shared/utilities/PageUtility';

function* getCommissionSchedulesSaga() {
  yield takeLatest(CommissionSchedulesActionType.GET_SCHEDULES, function*(
    action: ReturnType<typeof getCommissionSchedules>
  ) {
    const {page, agencyFilters, filter, sort} = action.payload;

    if (page) {
      yield put(changeCommissionSchedules(new LoadingAdditional(page)));
    } else {
      yield put(changeCommissionSchedules(new Loading(page)));
    }

    const result: AsyncResult<Page<CommissionSchedule>> = yield page
      ? call(mergeWithNextPage, {existingPage: page})
      : call(commissionScheduleApi.getSchedules, filter, agencyFilters, sort);

    const actionCreator = pipe(result, E.map(fromResult), E.fold(changeCommissionSchedules, changeCommissionSchedules));

    yield put(actionCreator);
  });
}

export default function*() {
  yield all([getCommissionSchedulesSaga()]);
}
